export const CARD_STATUS_LABELS = {
  pending: "Pending",
  active: "Active",
  voided: "Voided",
  exhausted: "Used up",
  expired: "Expired",
};

export const CARD_STATUS_COLORS = {
  pending: "gray",
  active: "success",
  voided: "error",
  exhausted: "gray",
  expired: "warning",
};

export const SOURCE_LABELS = {
  purchase: "Purchase",
  complimentary: "Free",
  import: "Gift Up import",
  merge: "Merge",
};

export const SCOPE_LABELS = {
  venues: "Selected venues",
  team: "Any team venue",
};

export const LEDGER_KIND_LABELS = {
  issue: "Issued",
  redeem: "Used",
  reverse: "Use reversed",
  refund_credit: "Refund credit",
  adjust: "Adjusted",
  void: "Voided",
  reactivate: "Reactivated",
  expire: "Expired",
  unexpire: "Expiry reversed",
  merge_in: "Merged in",
  merge_out: "Merged out",
  merge_recovered_out: "Recovered: original purchase reversed",
  merge_recovered_in: "Recovered from a merged card",
  merge_returned_out: "Returned to the card it came from",
  merge_returned_in: "Returned from a card whose purchase was reversed",
  chargeback: "Chargeback",
};

export const CODE_ROTATION_REASON_LABELS = {
  revealed: "Owner showed a new code in their account",
  emailed: "Owner emailed themselves a new code",
  staff_resent: "Staff resent the gift email with a new code",
  recipient_changed: "Staff changed the recipient and resent the gift email",
};

export const PURCHASE_REFUND_KIND_LABELS = {
  purchase: "Purchase refund",
  returned_spend: "Spend returned to buyer",
  returned_fees: "Purchase fees returned",
  held_for_dispute: "Held for dispute",
};

export const REFUND_STATE_LABELS = {
  pending: "Pending",
  failed: "Failed",
  refunded: "Refunded",
  held: "Held until the dispute is decided",
  resolved: "Dispute decided",
};

export const REFUND_STATE_COLORS = {
  pending: "warning",
  failed: "error",
  refunded: "success",
  held: "warning",
  resolved: "gray",
};

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";

export const formatDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
      })
    : "—";

export const searchKind = (value) => {
  const trimmed = value.trim();
  if (!trimmed) return "none";
  if (trimmed.includes("@")) return "email";
  if (/^#?\d{1,9}$/.test(trimmed)) return "order";
  if (trimmed.replace(/[\s-]/g, "").length === 4) return "last4";
  return "code";
};

export const currencySymbol = (currency) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: currency || "USD" })
    .formatToParts(0)
    .find((part) => part.type === "currency").value;

export const toCents = (value) => {
  const amount = Number.parseFloat(value);
  return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
};

export const parseAmountCents = (value) => {
  const text = String(value).trim();
  if (!/^(\d{1,3}(,\d{3})+|\d*)(\.\d{0,2})?$/.test(text)) return 0;
  const amount = Number(text.replace(/,/g, ""));
  return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
};
